export default {
  tiles: [
    {
      title: 'Jan Johannessen',
      titleSize: '3',
      description: 'Board Observer',
      descriptionSize: '1',
      subheader: 'Advisor at iGlobe Partners',
      subheaderLink:
        'https://www.iglobepartners.com/people-jan-johannessen.html',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Gibson Biddle',
      titleSize: '3',
      description: 'Board Observer',
      descriptionSize: '1',
      subheader: 'Former Product Leader at Netflix and Chegg',
      subheaderLink: 'https://www.linkedin.com/in/gibsonbiddle/',
      columnClass: 'matrix-2-col__tile',
    },
  ],
};
